import React from 'react';
import {
    Typography,
    Card,
} from '@mui/material';
import Box from '@mui/material/Box';


interface OnsoAnalysisProps {
    onsoScoreData: { [onso: string]: number };
}

const OnsoAnalysis: React.FC<OnsoAnalysisProps> = ({ onsoScoreData }) => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Card
                elevation={0}
                sx={{
                    width: '100%',
                    mt: 4,
                    mb: 4,
                    p: 2,
                }}
            >
                <Typography variant="h6" color="text.primary" sx={{ width: '90%', overflowX: 'auto', display: 'flex', justifyContent: { xs: 'normal', sm: 'center' }, alignItems: { xs: 'normal', sm: 'center' }, mb: 2, ml: { xs: 0, sm: 8 } }}>
                    Phonics: 音素学習表とあなたの重点課題一覧
                </Typography>
                {/* English Phonetic Chart: 6 rows, consonants (first 3), vowels (last 3) */}
                {/* {xs: 'column', sm: 'row' } */}
                <Box sx={{ width: '90%', overflowX: 'auto', display: 'flex', justifyContent: { xs: 'normal', sm: 'center' }, alignItems: { xs: 'normal', sm: 'center' }, mb: 2, ml: { xs: 0, sm: 10 } }} >
                    <table style={{ borderCollapse: 'collapse', width: '50%', textAlign: 'center' }}>
                        <tbody>
                            <tr>
                                <td
                                    style={{
                                        border: '1px solid #ccc',
                                        padding: 8,
                                        fontWeight: 'bold',
                                        writingMode: 'vertical-rl',
                                        WebkitWritingMode: 'vertical-rl',
                                        textOrientation: 'mixed',
                                        letterSpacing: '2px',
                                        fontSize: '16px',
                                        minWidth: '20px',
                                        transform: 'rotate(180deg)',
                                    }}
                                    rowSpan={3}
                                >
                                    Consonants
                                </td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['k'] !== undefined)
                                            ? onsoScoreData['k'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['k'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>k</b><br /><span style={{ fontSize: 12 }}>cat</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['s'] !== undefined)
                                            ? onsoScoreData['s'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['s'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>s</b><br /><span style={{ fontSize: 12 }}>see</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['ʃ(sh)'] !== undefined)
                                            ? onsoScoreData['ʃ(sh)'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['ʃ(sh)'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>ʃ</b><br /><span style={{ fontSize: 12 }}>she</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['tʃ'] !== undefined)
                                            ? onsoScoreData['tʃ'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['tʃ'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>tʃ</b><br /><span style={{ fontSize: 12 }}>check</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['t'] !== undefined)
                                            ? onsoScoreData['t'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['t'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>t</b><br /><span style={{ fontSize: 12 }}>tea</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['θ(th)"'] !== undefined)
                                            ? onsoScoreData['θ(th)'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['θ(th)'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>θ</b><br /><span style={{ fontSize: 12 }}>think</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['n'] !== undefined)
                                            ? onsoScoreData['n'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['n'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>n</b><br /><span style={{ fontSize: 12 }}>no</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['f'] !== undefined)
                                            ? onsoScoreData['f'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['f'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>f</b><br /><span style={{ fontSize: 12 }}>find</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['p'] !== undefined)
                                            ? onsoScoreData['p'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['p'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>p</b><br /><span style={{ fontSize: 12 }}>pen</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['r'] !== undefined)
                                            ? onsoScoreData['r'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['r'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>r</b><br /><span style={{ fontSize: 12 }}>red</span></td>
                                {/* Merge the two "対" cells into one using rowSpan=2 */}
                                <td style={{ border: '1px solid #ccc', padding: 8, fontStyle: 'italic' }} rowSpan={2}>↕ pair</td>
                            </tr>
                            <tr>
                                {/* No title cell here, as it's merged above */}
                                <td style={{
                                    border: '1px solid #ccc', padding: 8, minWidth: 48,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['g'] !== undefined)
                                            ? onsoScoreData['g'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['g'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>g</b><br /><span style={{ fontSize: 12 }}>go</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8, minWidth: 48,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['z'] !== undefined)
                                            ? onsoScoreData['z'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['z'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>z</b><br /><span style={{ fontSize: 12 }}>zoo</span></td>

                                <td style={{
                                    border: '1px solid #ccc', padding: 8, minWidth: 48,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['ʒ'] !== undefined)
                                            ? onsoScoreData['ʒ'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['ʒ'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>ʒ</b><br /><span style={{ fontSize: 12 }}>vision</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8, minWidth: 48,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['dʒ(j)'] !== undefined)
                                            ? onsoScoreData['dʒ(j)'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['dʒ(j)'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>dʒ</b><br /><span style={{ fontSize: 12 }}>jam</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8, minWidth: 48,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['d'] !== undefined)
                                            ? onsoScoreData['d'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['d'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>d</b><br /><span style={{ fontSize: 12 }}>dog</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8, minWidth: 48,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['ð'] !== undefined)
                                            ? onsoScoreData['ð'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['ð'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>ð</b><br /><span style={{ fontSize: 12 }}>this</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8, minWidth: 48,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['ŋ'] !== undefined)
                                            ? onsoScoreData['ŋ'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['ŋ'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>ŋ</b><br /><span style={{ fontSize: 12 }}>sing</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8, minWidth: 48,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['v'] !== undefined)
                                            ? onsoScoreData['v'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['v'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>v</b><br /><span style={{ fontSize: 12 }}>voice</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8, minWidth: 48,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['b'] !== undefined)
                                            ? onsoScoreData['b'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['b'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>b</b><br /><span style={{ fontSize: 12 }}>bad</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8, minWidth: 48,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['l'] !== undefined)
                                            ? onsoScoreData['l'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['l'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>l</b><br /><span style={{ fontSize: 12 }}>leg</span></td>
                                {/* The merged "対" cell is above, so remove this cell */}
                            </tr>
                            <tr>
                                {/* No title cell here, as it's merged above */}
                                <td style={{
                                    border: '1px solid #ccc', padding: 8, minWidth: 48,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['j'] !== undefined)
                                            ? onsoScoreData['j'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['j'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>j</b><br /><span style={{ fontSize: 12 }}>yes</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8, minWidth: 48,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['w'] !== undefined)
                                            ? onsoScoreData['w'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['w'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>w</b><br /><span style={{ fontSize: 12 }}>wet</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8, minWidth: 48,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['h'] !== undefined)
                                            ? onsoScoreData['h'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['h'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>h</b><br /><span style={{ fontSize: 12 }}>hat</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8, minWidth: 48,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['m'] !== undefined)
                                            ? onsoScoreData['m'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['m'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>m</b><br /><span style={{ fontSize: 12 }}>man</span></td>
                                <td style={{ border: '1px solid #ccc', padding: 8, fontStyle: 'italic' }} colSpan={7}>others</td>
                            </tr>

                            {/* Vowels Rows 1-3 with merged title cell */}
                            <tr>
                                <td
                                    style={{
                                        border: '1px solid #ccc',
                                        padding: 8,
                                        fontWeight: 'bold',
                                        writingMode: 'vertical-rl',
                                        textOrientation: 'mixed',
                                        letterSpacing: '2px',
                                        fontSize: '16px',
                                        minWidth: '20px',
                                        transform: 'rotate(180deg)',
                                    }}
                                    rowSpan={3}
                                >
                                    Vowels
                                </td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['æ'] !== undefined)
                                            ? onsoScoreData['æ'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['æ'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>æ</b><br /><span style={{ fontSize: 12 }}>cat</span></td> {/* a */}
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['ʌ'] !== undefined)
                                            ? onsoScoreData['ʌ'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['ʌ'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>ʌ</b><br /><span style={{ fontSize: 12 }}>cut</span></td> {/* ʌ */}
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['í'] !== undefined)
                                            ? onsoScoreData['í'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['í'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>í</b><br /><span style={{ fontSize: 12 }}>sit</span></td> {/* i */}
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['ʊ'] !== undefined)
                                            ? onsoScoreData['ʊ'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['ʊ'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>ʊ</b><br /><span style={{ fontSize: 12 }}>put</span></td> {/* u */}
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['é'] !== undefined)
                                            ? onsoScoreData['é'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['é'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>é</b><br /><span style={{ fontSize: 12 }}>bed</span></td> {/* e */}
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['ə'] !== undefined)
                                            ? onsoScoreData['ə'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['ə'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>ə</b><br /><span style={{ fontSize: 12 }}>about</span></td> {/* ə */}
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['ά'] !== undefined)
                                            ? onsoScoreData['ά'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['ά'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>ά</b><br /><span style={{ fontSize: 12 }}>hot</span></td> {/* o */}
                                <td style={{ border: '1px solid #ccc', padding: 8, fontStyle: 'italic' }} colSpan={4}>short</td>
                            </tr>
                            <tr>
                                {/* No title cell here, as it's merged above */}
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['ɑː'] !== undefined)
                                            ? onsoScoreData['ɑː'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['ɑː'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>ɑː</b><br /><span style={{ fontSize: 12 }}>car</span></td> {/* a: */}
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['ə́ː'] !== undefined)
                                            ? onsoScoreData['ə́ː'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['ə́ː'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>ə́ː</b><br /><span style={{ fontSize: 12 }}>bird</span></td> {/* ɜ: */}
                                <td style={{
                                    border: '1px solid #ccc', padding: 8, backgroundColor: '#e3f2fd',
                                    background:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['íː'] !== undefined)
                                            ? onsoScoreData['íː'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['íː'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>íː</b><br /><span style={{ fontSize: 12 }}>seat</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['úː'] !== undefined)
                                            ? onsoScoreData['úː'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['úː'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>úː</b><br /><span style={{ fontSize: 12 }}>food</span></td> {/* u: */}
                                <td style={{ border: '1px solid #ccc', padding: 8 }} colSpan={2}></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['ɔː'] !== undefined)
                                            ? onsoScoreData['ɔː'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['ɔː'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>ɔː</b><br /><span style={{ fontSize: 12 }}>saw</span></td> {/* o: */}
                                <td style={{ border: '1px solid #ccc', padding: 8, fontStyle: 'italic' }} colSpan={4}>long</td>
                            </tr>
                            <tr>
                                {/* Diphthongs row */}
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['éɪ'] !== undefined)
                                            ? onsoScoreData['éɪ'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['éɪ'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>éɪ</b><br /><span style={{ fontSize: 12 }}>day</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['ɑɪ'] !== undefined)
                                            ? onsoScoreData['ɑɪ'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['ɑɪ'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>ɑɪ</b><br /><span style={{ fontSize: 12 }}>my</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['ɔɪ'] !== undefined)
                                            ? onsoScoreData['ɔɪ'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['ɔɪ'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>ɔɪ</b><br /><span style={{ fontSize: 12 }}>boy</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['άʊ'] !== undefined)
                                            ? onsoScoreData['άʊ'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['άʊ'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>άʊ</b><br /><span style={{ fontSize: 12 }}>now</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['óʊ'] !== undefined)
                                            ? onsoScoreData['óʊ'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['óʊ'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>óʊ</b><br /><span style={{ fontSize: 12 }}>coast</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['ɪə'] !== undefined)
                                            ? onsoScoreData['ɪə'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['ɪə'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>ɪə</b><br /><span style={{ fontSize: 12 }}>here</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['eə'] !== undefined)
                                            ? onsoScoreData['eə'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['eə'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>eə</b><br /><span style={{ fontSize: 12 }}>there</span></td>
                                <td style={{
                                    border: '1px solid #ccc', padding: 8,
                                    backgroundColor:
                                        onsoScoreData && !Array.isArray(onsoScoreData) && typeof onsoScoreData === 'object' && (onsoScoreData['ʊə'] !== undefined)
                                            ? onsoScoreData['ʊə'] < 60
                                                ? '#d1c4e9'
                                                : onsoScoreData['ʊə'] < 95
                                                    ? '#ede7f6'
                                                    : undefined
                                            : undefined
                                }}><b>ʊə</b><br /><span style={{ fontSize: 12 }}>tour</span></td>
                                <td style={{ border: '1px solid #ccc', padding: 8, fontStyle: 'italic' }} colSpan={3}>diphthongs</td>
                                {/* <td style={{ border: '1px solid #ccc', padding: 8 }} colSpan={2}></td> */}
                            </tr>
                        </tbody>
                    </table>
                </Box>
            </Card>
        </Box >
    )
}

export default OnsoAnalysis;
export type { OnsoAnalysisProps };
